module.exports = __webpack_public_path__ + "img/commingsoon.f473da06.jpg";